import { AnalyticsBrowser } from '@segment/analytics-next'

const writeKey = process.env.REACT_APP_SEGMENT_WRITE_KEY
const env = process.env.REACT_APP_ENV ?? 'production'
const devEnvs = ['local', 'development']

const disabled = process.env.NODE_ENV !== 'production' || devEnvs.includes(env) || !writeKey

export const segmentClient = disabled
  ? null
  : AnalyticsBrowser.load({ writeKey })

export const SOURCE_APP = 'tournament'

const stamp = (params = {}) => ({ ...params, source_app: SOURCE_APP, env })

export const segmentTrack = (event, params = {}) => {
  try {
    segmentClient?.track(event, stamp(params))?.catch?.(() => {})
  } catch (_e) {}
}

export const segmentIdentify = (userId, traits = {}) => {
  if (userId == null) return
  try {
    segmentClient?.identify(String(userId), stamp(traits))?.catch?.(() => {})
  } catch (_e) {}
}

export const segmentPage = (name, properties = {}) => {
  try {
    segmentClient?.page(name, stamp(properties))?.catch?.(() => {})
  } catch (_e) {}
}

export const segmentReset = () => {
  try {
    segmentClient?.reset?.()
  } catch (_e) {}
}
